module.exports = "<div class=\"arrow-down-wrap\" (click)=\"scrollDown()\">\r\n    <span class=\"arrow-down\"></span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// E:/MBP/BloomyNG/src/app/downarrow/downarrow.component.html
// module id = ../../../../../src/app/downarrow/downarrow.component.html
// module chunks = main